
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/[pid]",
      function () {
        return require("private-next-pages/download/[pid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/download/[pid]"])
      });
    }
  